module.exports = __webpack_public_path__ + "img/gl.36f45919.svg";